import { supabase } from "../../../supabaseClient";

export async function processVerifiedAverages(tournamentId) {
  const { data, error } = await supabase
    .from("verificationStates")
    .select("isVerified")
    .eq("tournamentId", tournamentId)
    .eq("entityType", "averages");

  if (error) throw error;

  // If no verification state exists yet, return false (not verified)
  if (!data || data.length === 0) {
    return false;
  }

  // If multiple records exist, use the first one (shouldn't happen with proper constraints)
  return data[0]?.isVerified || false;
}
